import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './edit-finding-category-dialog.controller';
import template from './edit-finding-category-dialog.html';
import validator, { name as validatorName } from '../messages/finding-category-unique-name.validator.directive';
import nameTpl from '../messages/finding-category.name.messages.html';

// import notesTpl from '../validation/finding-category.notes.messages.html'; <-- missing template!


class dialogService {
  getOptions($event, { findingCategory }) {
    return {
      controller,
      controllerAs: 'editFindingCategoryDialogVM',
      locals: {
        findingCategory
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.editFindingCategoryDialog', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .controller()
  .directive(validatorName, validator)
  .service('editFindingCategoryDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('finding-category.name.messages.html', nameTpl);
    // $templateCache.put('finding-category.notes.messages.html', notesTpl);
  })
  .name;
